import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";
import Navbar from "./Navbar";
import ProfileCard from "./ProfileCard";

const EmployeeLayout = ({ children }) => {
  const [emp, setEmp] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    loadProfile();
  }, []);

  const loadProfile = async () => {
    try {
      const token = localStorage.getItem("emp_token");
      if (!token) return navigate("/login");

      const res = await api.get("/employee/me", {
        headers: { Authorization: `Bearer ${token}` },
      });
      
      setEmp(res.data);
    } catch (err) {
      console.error("Error loading profile", err);
      navigate("/login");
    }
  };

  if (!emp)
    return (
      <div className="emp-shell">
        <p>Loading...</p>
      </div>
    );

  return (
    <div className="emp-shell">
      <Navbar onLogout={() => {
        localStorage.removeItem("emp_token");
        navigate("/login");
      }}/>

      <ProfileCard emp={emp} />

      <div className="emp-card" style={{ marginTop: "20px" }}>
        {children}
      </div>
    </div>
  );
};

export default EmployeeLayout;
